import { render, staticRenderFns } from "./ObjectsView.vue?vue&type=template&id=226982b8&scoped=true&"
import script from "./ObjectsView.vue?vue&type=script&lang=js&"
export * from "./ObjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsView.vue?vue&type=style&index=0&id=226982b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226982b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon})
